//
import { API } from "../../api";
async function change_password(request) {
    // console.log("change_password -> request", request);
    return await new API().apiPut({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `user/change_password`, //
        content: request,
    });
}
export { 
// IForgotPasswordRequest,
change_password, };
